module.exports = __webpack_public_path__ + "1touch.13c770e98116523def50.ttf";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/1touch.ttf
// module id = ../../../../../src/fonts/1touch.ttf
// module chunks = 3